import React, { useRef, useState, useEffect } from "react";
import LeftArrow from "../assets/left-arrow.svg";
import RightArrow from "../assets/right-arrow.svg";
import "../styles/cardSlider.css"; 
import WhatWeDoData from "../data/WhatWeDoData";

const CardSlider = () => {
  const sliderRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true); // Assume right is available initially

  // Function to update scroll state
  const updateScrollState = () => {
    if (!sliderRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;

    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
  };

  const scroll = (direction) => {
    if (!sliderRef.current) return;

    const cardWidth = document.querySelector(".card")?.offsetWidth || 300; // Get card width
    const scrollAmount = cardWidth * 3 + 20 * 3; // 3 cards + gap space

    sliderRef.current.scrollBy({ 
      left: direction === "left" ? -scrollAmount : scrollAmount, 
      behavior: "smooth" 
    });

    setTimeout(updateScrollState, 500); // Update scroll state after movement
  };

  useEffect(() => {
    updateScrollState(); // Check scroll state on mount
  }, []);

  return (
    <div className="slider-container">
      {/* Left Arrow Button (Hidden if cannot scroll left) */}
      <button 
        className={`slider-button prev ${!canScrollLeft ? "disabled" : ""}`} 
        onClick={() => scroll("left")} 
        disabled={!canScrollLeft}
      >
        <img src={LeftArrow} alt="leftarrow" />
      </button>

      {/* Card Wrapper */}
      <div className="card-slider" ref={sliderRef} onScroll={updateScrollState}>
        {WhatWeDoData.map((item) => (
          <div key={item.id} className="card">
            <div className="card-image">
            <img src={item.image} alt={`${item.title}-image`} />
            </div>
            <div className="card-text">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <button className="what-btn">
              <a href={item.link}>Know More</a>
            </button>
            </div>
           
            
          </div>
        ))}
      </div>

      {/* Right Arrow Button (Hidden if cannot scroll right) */}
      <button 
        className={`slider-button next ${!canScrollRight ? "disabled" : ""}`} 
        onClick={() => scroll("right")} 
        disabled={!canScrollRight}
      >
        <img src={RightArrow} alt="right-arrow" />
      </button>
    </div>
  );
};

export default CardSlider;
